import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import { Close } from '../asset';
import { joinCn } from '../util';
import style from './style';
import type { VChipProps } from './type';

const VChip = forwardRef(
  (props: VChipProps, ref: ForwardedRef<HTMLDivElement>) => {
    const {
      children,
      className,
      onDelete,
      disabled,
      valid = true,
      ...divProps
    } = props;

    return (
      <div
        ref={ref}
        className={joinCn(
          { [style.chip]: valid, [style.error]: !valid },
          className,
        )}
        aria-disabled={disabled}
        role="button"
        {...divProps}
      >
        <span className={style.text}>{children}</span>
        {!disabled && (
          <Close
            aria-disabled={disabled}
            role="button"
            onClick={onDelete}
            className={style.deleteIcon}
          />
        )}
      </div>
    );
  },
);

export default VChip;
